import { STRACK_COLOURS } from '@frontend/strack'

export const PITCH_FILL = STRACK_COLOURS.pitch.background
export const PITCH_LINE = STRACK_COLOURS.pitch.lines
export const PITCH_LINE_WIDTH = 2
export const CANVAS_PADDING = 20
